import styled from 'styled-components';
export const NeedHelpWrapper = styled.section `
  margin-bottom: 40px;
  .csl-accordion {
    background: ${(props) => {
    if (props.theme?.brand === 'bos') {
        return props.theme.color_background_neutral_default_2;
    }
    return props.theme.color_action_background_primary_disabled;
}};
    .csl-paragraph {
      .csl-text-s2 {
        a {
          color: inherit;
          .csl-text-s2 {
            color: inherit;
            font-weight: inherit;
          }
        }
      }
    }
    .csl-accordion__header {
      background: inherit;
      .csl-accordion__icon-container {
        background: inherit;
      }
      &:hover {
        background: inherit;
        .csl-accordion__icon-container {
          background: inherit;
        }
      }
    }
  }
`;
//# sourceMappingURL=style.js.map